import React, { useState, useEffect, useCallback } from 'react';
import { functions } from '../firebase/config';
import { httpsCallable } from 'firebase/functions';
import Header from '../components/Header';

const CategoriesPage = ({ navigateTo, currentPage }) => {
    const [categories, setCategories] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState('');
    const [newCategoryName, setNewCategoryName] = useState('');

    const fetchUserCategories = useCallback(async () => {
        setIsLoading(true); setError('');
        try {
            const getUserCategories = httpsCallable(functions, 'getUserCategories');
            const result = await getUserCategories();
            setCategories(result.data);
        } catch (err) { setError(err.message); } finally { setIsLoading(false); }
    }, []);

    useEffect(() => { fetchUserCategories(); }, [fetchUserCategories]);

    const handleAddCategory = async (e) => {
        e.preventDefault();
        if (!newCategoryName) return;
        try {
            await httpsCallable(functions, 'addCustomCategory')({ name: newCategoryName });
            setNewCategoryName('');
            fetchUserCategories();
        } catch (err) { setError(err.message); }
    };

    const handleDeleteCategory = async (categoryId) => {
        if (!window.confirm("Are you sure you want to delete this custom category?")) return;
        try {
            await httpsCallable(functions, 'deleteCustomCategory')({ categoryId });
            fetchUserCategories();
        } catch (err) { setError(err.message); }
    };

    return (
        <div className="max-w-4xl mx-auto p-4 md:p-8">
            <Header title="Manage Your Custom Categories" navigateTo={navigateTo} currentPage={currentPage} />
            <div className="bg-white p-6 rounded-lg shadow-md mb-8">
                <h2 className="text-xl font-semibold mb-4">Add a Custom Category</h2>
                <p className="text-gray-600 mb-4">Add personal categories to supplement the default list.</p>
                <form onSubmit={handleAddCategory} className="flex items-center space-x-2">
                    <input type="text" value={newCategoryName} onChange={(e) => setNewCategoryName(e.target.value)} placeholder="e.g., Hobbies, Gifts" className="flex-grow px-3 py-2 border border-gray-300 rounded-md shadow-sm" required />
                    <button type="submit" className="px-5 py-2 font-medium text-white bg-blue-600 rounded-md hover:bg-blue-700">Add</button>
                </form>
                {error && <p className="text-red-500 text-sm mt-2">{error}</p>}
            </div>
            <div className="bg-white p-6 rounded-lg shadow-md">
                <h2 className="text-xl font-semibold mb-4">Your Custom List</h2>
                {isLoading ? <p>Loading categories...</p> : (
                    <ul className="divide-y divide-gray-200">
                        {categories.map(cat => (
                            <li key={cat.id} className="py-3 flex justify-between items-center">
                                <span className="text-gray-800">{cat.name}</span>
                                <button onClick={() => handleDeleteCategory(cat.id)} className="text-red-500 hover:text-red-700 text-sm font-medium">Delete</button>
                            </li>
                        ))}
                    </ul>
                )}
            </div>
        </div>
    );
};

export default CategoriesPage;